import { httpClient } from '@shared/infrastructure/http/http';
import { Language } from '@shared/domain/language/language.aggregate';
import { configuration } from 'configuration';

export const languageRepositoryImplementation = {
  getLanguages: () => {
    return httpClient.get<Language[]>(
      `${configuration.api.baseUrl}/api/languages`
    );
  }
};
